import InitialDataService from './initialData/initialData.service';
import employeeRepositoryService from './employeeRepository/employeeRepository.service';
import managerRepositoryService from './managerRepository/managerRepository.service';
import InitialDataManagerService from  './initialData/initialDataManager.service';
import FoodUserDataService from './services/foodUserData.service';
import foodBenefitService from './services/foodBenefit.service';
import myFoodBenefitHelper from './services/myFoodBenefitHelper.service';
import foodDelegationService from './delegationRepository/foodDelegationRepository.service';

let foodBenefitCommon = angular.module('food-benefit.common', [])
  .service('FoodBenefitInitialDataService', InitialDataService)
  .service('FoodBenefitEmployeeRepositoryService', employeeRepositoryService)
  .service('FoodBenefitManagerRepositoryService', managerRepositoryService)
  .service('FoodBenefitInitialDataManagerService', InitialDataManagerService)
  .service('FoodBenefitUserDataService', FoodUserDataService)
  .service('foodBenefitService', foodBenefitService)
  .service('myFoodBenefitHelper', myFoodBenefitHelper)
  .service('foodDelegationService', foodDelegationService)

  .name;

export default foodBenefitCommon;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/food-benefit.common.js